/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFieldinfoNoLookupJoin.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/fieldinfo-no-lookup-join";

export class AutogenModelFieldinfoNoLookupJoin<RowType extends ModelRow> extends Endpoint<RowType, RowFieldinfoNoLookupJoinFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFieldinfoNoLookupJoin extends ModelRow<RowFieldinfoNoLookupJoinFields> {
	constructor(values?: Partial<RowFieldinfoNoLookupJoinFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFieldinfoNoLookupJoinFields {
	allow_nulls: string;
	browse_file: string;
	caption: string;
	company_id: string;
	custom_field: string;
	data_length: number;
	data_type: string;
	decimal_precision: number;
	default_value: string;
	display_label: string;
	domain_name: string;
	field_name: string;
	help_line: string;
	is_thumb_multi_comp: string;
	long_desc: string;
	master_field: string;
	master_table: string;
	ordinal_position: number;
	primary_key_seq: number;
	required: string;
	table_name: string;
	upshifted: string;
	v6_field_name: string;
	v6_table_name: string;
	value_constraints: string;
	workorder: number;
}

